import { render, staticRenderFns } from "./institutionsedit.vue?vue&type=template&id=a21a7526&"
import script from "./institutionsedit.vue?vue&type=script&lang=js&"
export * from "./institutionsedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports